import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1559f679&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=1559f679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1559f679",
  null
  
)

export default component.exports